import type { App } from "app/App";
import { UpdateForcerPopup } from "../game/views/popups/forceUpdate/UpdateForcerPopup";
import type { UpdateForcerPopupConfig } from "../game/views/popups/forceUpdate/UpdateForcerPopup";
import type { AppStateController } from "../app/state/AppStateController";
import type { Platform } from "../app/platform/Platform";
import type { PopupStackController } from "../popups/PopupStackController";

export function openForceUpdatePopup(app: App): void {
    const {
        controller: { popups },
        stateController,
        platform,
    } = app as {
        controller: { popups: PopupStackController };
        stateController: AppStateController;
        platform: Platform;
    };

    // Check if any popup is already open - don't show force update popup over other popups
    if (popups.isAnyPopupOpened()) {
        console.log('Force update popup skipped - another popup is already open');
        return;
    }
    const isForceUpdate = platform.forceUpdate?.isForceUpdate() ?? false;
    const config: UpdateForcerPopupConfig = {
        state: stateController,
        isOptionalUpdate: !isForceUpdate,
    };

    const popup = new UpdateForcerPopup(config);

    popup.onUpdateButtonClicked.connect(() => {
        platform.forceUpdate?.update();
        void popups.closeActivePopup();
    });

    popup.onCloseButtonClicked.connect(() => {
        platform.forceUpdate?.cancelUpdate();
        void popups.closeActivePopup();
    });

    void popups.addPopup({
        popupInstance: popup,
        settings: { overlayFillOpacity: 0.7, hideRays: true, overlay: false },
    });
    platform.forceUpdate?.onPopupShown();
}